const key = 'servicezone:pending-verification';

export function getPendingVerification() {
  try {
    const value = JSON.parse(sessionStorage.getItem(key));
    if (!value || typeof value.email !== 'string' || !value.email.includes('@')) return null;
    return { email: value.email, resendUntil: Number(value.resendUntil) || 0 };
  } catch (_) { return null; }
}

export function savePendingVerification(email, seconds = 0) {
  const value = { email: email.trim(), resendUntil: seconds > 0 ? Date.now() + seconds * 1000 : 0 };
  try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) { /* Storage can be disabled. */ }
  return value;
}

export function clearPendingVerification() {
  try { sessionStorage.removeItem(key); } catch (_) { /* Storage can be disabled. */ }
}

export const verificationError = error => {
  const data = error?.response?.data;
  return data?.message || Object.values(data?.errors || {}).flat().find(value => typeof value === 'string')
    || 'İşlem tamamlanamadı. Lütfen tekrar deneyin.';
};
